import axios from 'axios'
import { CADASTRAR_ENDERECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarEndereco (endereco) {
  const url = `${URL}/enderecos/cadastrar`;
  return dispatch => axios.post(url,endereco , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_ENDERECO,
        payload: response
      })
  );
}
